import DefaultLobbyItem from '../common/lobby/DefaultLobbyItem';
import { spacingGrouping } from './grouping';
import SpacingStyles from './SpacingStyles';
import { GlobalDesignAction } from '../types';

const spacingAction: GlobalDesignAction<'spacingStyles'> = {
  panel: SpacingStyles,
  lobbyItem: DefaultLobbyItem,
  grouping: spacingGrouping,
};

export default spacingAction;
